export default __webpack_public_path__ + "static/media/Satpuras.f76bc7eb.jpg";